/** สี + FA icon (Iconify) เฉพาะแต่ละเมนู — กล่องพาสเทลแบบ BSR-DMS */
const T = (icon, color, bg) => ({ icon, color, bg });

const DEFAULT_THEME = T('fa6-solid:circle', '#64748b', '#f1f5f9');

/** จัดกลุ่มตามไฟล์ SVG เดิมใน /assets/icons/navbar */
export const MENU_ICON_BY_SRC = {
  // กลุ่มหลัก (config-navigation)
  'ic_home': T('fa6-solid:house-chimney', '#2563eb', '#eff6ff'),
  'ic_dataEmployee': T('fa6-solid:id-card', '#0891b2', '#ecfeff'),
  'ic_orientation': T('fa6-solid:chalkboard-user', '#7c3aed', '#f5f3ff'),
  'ic_evalution': T('fa6-solid:clipboard-check', '#d97706', '#fffbeb'),
  'ic_recruit': T('fa6-solid:user-plus', '#16a34a', '#f0fdf4'),
  'ic_allReport': T('fa6-solid:chart-column', '#4f46e5', '#eef2ff'),
  'ic_reward2': T('fa6-solid:hand-holding-heart', '#db2777', '#fdf2f8'),
  'ic_docOther': T('fa6-solid:folder-open', '#ca8a04', '#fefce8'),
  'ic_manageDept': T('fa6-solid:gears', '#e11d48', '#fff1f2'),
  'ic_resign': T('fa6-solid:door-open', '#dc2626', '#fef2f2'),

  // ข้อมูลพนักงาน / จัดการ
  'ic_user': T('fa6-solid:user', '#2563eb', '#eff6ff'),
  'ic_allEmployee': T('fa6-solid:users', '#9333ea', '#faf5ff'),
  'ic_manageDept2': T('fa6-solid:building', '#0d9488', '#f0fdfa'),
  'ic_branch': T('fa6-solid:store', '#0891b2', '#ecfeff'),
  'ic_pdpa': T('fa6-solid:shield-halved', '#16a34a', '#f0fdf4'),
  'ic_healt': T('fa6-solid:heart-pulse', '#e11d48', '#fff1f2'),
  'ic_welfare': T('fa6-solid:sack-dollar', '#d97706', '#fffbeb'),
  'ic_employeeDamageOrLoan': T('fa6-solid:scale-balanced', '#7c3aed', '#f5f3ff'),
  'ic_manageAssets': T('fa6-solid:boxes-stacked', '#475569', '#f8fafc'),
  'ic_prepareAsset': T('fa6-solid:box-open', '#0284c7', '#f0f9ff'),
  'ic_myCalendar': T('fa6-solid:calendar-days', '#2563eb', '#eff6ff'),
  'ic_reqEditCalendar': T('fa6-solid:calendar-plus', '#0891b2', '#ecfeff'),

  // ฝึกอบรม
  'ic_orientationSub': T('fa6-solid:book-open', '#7c3aed', '#f5f3ff'),
  'ic_trainingHostory': T('fa6-solid:clock-rotate-left', '#0d9488', '#f0fdfa'),
  'ic_trainingRequest': T('fa6-solid:paper-plane', '#2563eb', '#eff6ff'),
  'ic_streaming': T('fa6-solid:video', '#dc2626', '#fef2f2'),

  // ประเมิน
  'ic_probationEva': T('fa6-solid:clipboard-list', '#d97706', '#fffbeb'),
  'ic_proEvaYear': T('fa6-solid:calendar-check', '#4f46e5', '#eef2ff'),
  'ic_calibrate': T('fa6-solid:users-gear', '#0d9488', '#f0fdfa'),
  'ic_skillHard': T('fa6-solid:screwdriver-wrench', '#0d9488', '#f0fdfa'),
  'ic_sumProEva': T('fa6-solid:chart-pie', '#16a34a', '#f0fdf4'),
  'ic_settingTest': T('fa6-solid:sliders', '#64748b', '#f1f5f9'),
  'ic_test': T('fa6-solid:flask', '#0891b2', '#ecfeff'),
  'ic_testQuestions': T('fa6-solid:circle-question', '#7c3aed', '#f5f3ff'),
  'ic_leaderboard': T('fa6-solid:trophy', '#ca8a04', '#fefce8'),
  'ic_talent': T('fa6-solid:star', '#db2777', '#fdf2f8'),
  'ic_skillGap': T('fa6-solid:bullseye', '#dc2626', '#fef2f2'),
  'ic_nineBox': T('fa6-solid:table-cells', '#7c3aed', '#f5f3ff'),
  'ic_chat': T('fa6-solid:comments', '#0891b2', '#ecfeff'),
  'ic_chart': T('fa6-solid:chart-line', '#2563eb', '#eff6ff'),
  'ic_analytics': T('fa6-solid:chart-area', '#4f46e5', '#eef2ff'),

  // สมัครงาน
  'ic_listRecruit': T('fa6-solid:briefcase', '#16a34a', '#f0fdf4'),
  'ic_listReqEmployee': T('fa6-solid:list-check', '#0284c7', '#f0f9ff'),
  'ic_reqEmployee': T('fa6-solid:user-tie', '#0d9488', '#f0fdfa'),
  'ic_recruitment': T('fa6-solid:magnifying-glass', '#7c3aed', '#f5f3ff'),
  'ic_candidateEvaluation': T('fa6-solid:user-check', '#ea580c', '#fff7ed'),
  'ic_applicationArchive': T('fa6-solid:box-archive', '#64748b', '#f1f5f9'),
  'ic_deptOpen': T('fa6-solid:door-open', '#0891b2', '#ecfeff'),
  'ic_deptOnOpen': T('fa6-solid:building-circle-arrow-right', '#2563eb', '#eff6ff'),
  'ic_heart': T('fa6-solid:heart', '#e11d48', '#fff1f2'),

  // ลาออก / รายงาน
  'ic_resignation': T('fa6-solid:file-signature', '#dc2626', '#fef2f2'),
  'ic_resignationList': T('fa6-solid:clipboard-user', '#e11d48', '#fff1f2'),
  'ic_report': T('fa6-solid:flag', '#d97706', '#fffbeb'),
  'ic_reportEmployee': T('fa6-solid:file-lines', '#2563eb', '#eff6ff'),
  'ic_reportEvaluation': T('fa6-solid:file-circle-check', '#16a34a', '#f0fdf4'),
  'ic_reportResign': T('fa6-solid:file-export', '#7c3aed', '#f5f3ff'),
  'ic_document': T('fa6-solid:file', '#475569', '#f8fafc'),

  // สวัสดิการ / อื่นๆ
  'ic_rewardSub': T('fa6-solid:gift', '#db2777', '#fdf2f8'),
  'ic_claim': T('fa6-solid:money-bill-transfer', '#d97706', '#fffbeb'),
};

/** กลุ่มหลักตาม title ใน navConfig */
export const MENU_GROUP_BY_TITLE = {
  Home: T('fa6-solid:house-chimney', '#2563eb', '#eff6ff'),
  ข้อมูลพนักงาน: T('fa6-solid:id-card', '#0891b2', '#ecfeff'),
  ฝึกอบรม: T('fa6-solid:chalkboard-user', '#7c3aed', '#f5f3ff'),
  ประเมิน: T('fa6-solid:clipboard-check', '#d97706', '#fffbeb'),
  สมัครงาน: T('fa6-solid:user-plus', '#16a34a', '#f0fdf4'),
  รายงาน: T('fa6-solid:chart-column', '#4f46e5', '#eef2ff'),
  สวัสดิการ: T('fa6-solid:hand-holding-heart', '#db2777', '#fdf2f8'),
  อื่นๆ: T('fa6-solid:folder-open', '#ca8a04', '#fefce8'),
  การจัดการ: T('fa6-solid:gears', '#e11d48', '#fff1f2'),
  ลาออก: T('fa6-solid:door-open', '#dc2626', '#fef2f2'),
};

function basenameFromSrc(src = '') {
  const file = String(src).split('/').pop() || '';
  return file.replace(/\.svg$/i, '');
}

export function getMenuIconTheme({ itemId, src, title } = {}) {
  if (title && MENU_GROUP_BY_TITLE[title]) return MENU_GROUP_BY_TITLE[title];
  const key = itemId || basenameFromSrc(src);
  if (key && MENU_ICON_BY_SRC[key]) return MENU_ICON_BY_SRC[key];
  return DEFAULT_THEME;
}
